import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "h-4 w-auto text-red-600 hover:text-red-800",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "mt-1 inline-flex w-full justify-around"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-1 h-4 w-4",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Lisa uus ")
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 w-full flex justify-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "transition duration-300 ease-in-out inline-flex items-center px-4 py-2 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
  }, " Salvesta ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_ManagersDropdown = _resolveComponent("ManagersDropdown")!
  const _component_AlternativeManagersDropdown = _resolveComponent("AlternativeManagersDropdown")!

  return (_openBlock(), _createElementBlock("form", {
    class: "space-y-4",
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClinicAdd && _ctx.onClinicAdd(...args)), ["prevent"]))
  }, [
    _createVNode(_component_InputField, {
      label: "Kliiniku nimi",
      isAutocomplete: false,
      fieldId: "clinicName",
      required: "",
      value: _ctx.name,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
    }, null, 8, ["value"]),
    _createVNode(_component_InputField, {
      label: "Kiirgustegevusloa omaja",
      isAutocomplete: false,
      fieldId: "clinicWorkerLicenceHolder",
      required: "",
      value: _ctx.radiationPracticeLicenseHolder,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.radiationPracticeLicenseHolder) = $event))
    }, null, 8, ["value"]),
    _createVNode(_component_ManagersDropdown, {
      onOnManager: _cache[2] || (_cache[2] = (e) => (_ctx.managerUID = e)),
      initialManagerUID: _ctx.managerUID
    }, null, 8, ["initialManagerUID"]),
    _createVNode(_component_AlternativeManagersDropdown, {
      onOnAlternativeManager: _cache[3] || (_cache[3] = (e) => (_ctx.alternativeManagerUID = e)),
      initialAlternativeManagerUID: _ctx.alternativeManagerUID
    }, null, 8, ["initialAlternativeManagerUID"]),
    _createVNode(_component_InputField, {
      label: "Kasutajate arv",
      fieldId: "usersCount",
      isAutocomplete: false,
      required: "",
      value: _ctx.usersCount,
      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.usersCount) = $event)),
      inputType: _ctx.InputFieldType.NUMBER
    }, null, 8, ["value", "inputType"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.licenseNos, (_, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "mt-4 inline-flex items-center w-full",
        key: `licence_no_${index}`
      }, [
        _createVNode(_component_InputField, {
          class: "flex-1",
          label: "Kiirgustegevusloa number",
          isAutocomplete: false,
          fieldId: "licenceNumber",
          required: "",
          value: _ctx.licenseNos[index],
          "onUpdate:value": ($event: any) => ((_ctx.licenseNos[index]) = $event)
        }, null, 8, ["value", "onUpdate:value"]),
        (index !== 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "flex-shrink-0 flex pl-4 focus:outline-none",
              onClick: ($event: any) => (_ctx.removeLicenceNo(index))
            }, _hoisted_3, 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    (_ctx.showAddNewLicenceNoButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addNewLicenceNo && _ctx.addNewLicenceNo(...args))),
            type: "button",
            class: "uppercase tracking-wider hover:bg-orange-100 transition duration-300 ease-in-out flex items-center px-3 py-2 border border-transparent text-xs leading-4 font-medium rounded-md text-gray-500 hover:text-orange-700 focus:outline-none"
          }, _hoisted_7)
        ]))
      : _createCommentVNode("", true),
    _hoisted_8
  ], 32))
}